import { BrowserModule } from '@angular/platform-browser';
import { ErrorHandler, NgModule } from '@angular/core';
import { HttpModule } from '@angular/http';

import { AppComponent } from './app.component';
import { IfNullPipe } from './core/main.pipe';

import { GlobalErrorHandler } from './shared/error/error-handler';
import { GlobalErrorService } from './shared/error/error.service';

import { RoutingModule } from './routing.module';
import { AngularFireModule } from 'angularfire2';
import { environment } from '../environments/environment';
import { StateService } from './state/state.service';
import { CommandBusService } from './state/command/command-bus.service';
import { CommandHandlerRegistryService } from './state/command/command-registry.service';
import { CommandHandlerConfiguratorService } from './state/command-handler-configurator.service';
import { AngularFireAuthModule } from 'angularfire2/auth';
import { FormValidationHelper } from './core/util/form-validation.helper';
import { EndpointService } from './core/endpoint.service';
import { NativeOptionsBuilder } from './core/native-options-builder';
import './rxjs.operators';
import { AuthenticatedGuard } from './state/guard/authenticated-guard';
import { PanelTypeGuard } from './core/service/panel-type-guard';
import { LicensedGuard } from './state/guard/licensed-guard';
import { AuthCommandHandlerService } from './state/auth/auth-command-handler.service';
import { OrderCommandHandlerService } from './state/order/order-command-handler.service';
import { SharedModule } from './shared/shared.module';
import { HasChosenPurchaseGuard } from './state/guard/has-chosen-purchase-guard';
import { AdminGuard } from './state/guard/admin-guard';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { PanelLayoutModule } from './shared/panel-layout/panel-layout.module';
import { PanelCliLayoutModule } from './shared/panel-cli-layout/panel-cli-layout.module';
import { EcommerceLayoutModule } from './shared/ecommerce-layout/ecommerce-layout.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { DevGuard } from './state/guard/dev-guard';
import { AuthRedirectorService } from './core/auth/auth-redirector.service';
import { NbSpinnerService, NbThemeModule } from '@nebular/theme';
import { AuthService } from './core/auth/auth.service';
import { LoginDaoService } from './core/dao-service/login-dao.service';
import { AngularFireStorage, AngularFireStorageModule } from "angularfire2/storage";
import { ShipmentCommandHandlerService } from "./state/shipment/shipment-command-handler.service";
import { MyFoglio } from './core/service/myfoglio';
import { Analytics } from './core/service/analytics';
import { KaskoCommandHandlerService } from './state/kasko/kasko-command-handler.service';
import { FinancingCommandHandlerService } from './state/financing/financing-command-handler.service';
import { DropshippingCommandHandlerService } from './state/dropshipping/dropshipping-command-handler.service';
import { RicondizionatoCommandHandlerService } from './state/ricondizionato/ricondizionato-command-handler.service';
@NgModule({
  declarations: [
    IfNullPipe,
    AppComponent,
  ],
  imports: [
    SharedModule,
    BrowserModule,
    HttpModule,
    RoutingModule,
    AngularFireModule.initializeApp(environment.firebase),
    AngularFireAuthModule,
    AngularFireStorageModule,
    BrowserAnimationsModule,

    NbThemeModule.forRoot({ name: 'light' }),
    NgbModule.forRoot(),
    PanelLayoutModule.forRoot(),
    PanelCliLayoutModule.forRoot(),
    EcommerceLayoutModule.forRoot()
  ],
  providers: [
    AdminGuard,
    DevGuard,
    LicensedGuard,
    HasChosenPurchaseGuard,
    AuthenticatedGuard,
    PanelTypeGuard,
    MyFoglio,
    Analytics,
    StateService,
    AuthService,
    LoginDaoService,
    CommandBusService,
    CommandHandlerRegistryService,
    CommandHandlerConfiguratorService,
    AuthCommandHandlerService,
    OrderCommandHandlerService,
    ShipmentCommandHandlerService,
    KaskoCommandHandlerService,
    FinancingCommandHandlerService,
    DropshippingCommandHandlerService,
    RicondizionatoCommandHandlerService,
    EndpointService,
    AuthRedirectorService,
    FormValidationHelper,
    NativeOptionsBuilder,
    GlobalErrorService,
    NbSpinnerService,
    AngularFireStorage,
    {
      provide: ErrorHandler,
      useClass: GlobalErrorHandler
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}



// WEBPACK FOOTER //
// ./src/app/app.module.ts